/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */
import { assertSlots, mergeClasses } from '@fluentui/react-components';
import { ForwardRefComponent } from '@fluentui/react-utilities';
import * as React from 'react';

import { useStyles } from "./PageTitle.styles"
import { PageTitleProps, PageTitleSlots } from './PageTitle.types';
import { usePageTitle_unstable } from './usePageTitle'

export const PageTitle = React.forwardRef((props, ref) => {
  const state = usePageTitle_unstable(props, ref);

  const classes = useStyles();
  state.description.className = classes.description;
  state.heading.className = classes.heading;
  state.root.className = mergeClasses(classes.container, props.className);

  assertSlots<PageTitleSlots>(state);
  return (
    <state.root>
      <state.heading />
      <state.description />
    </state.root>
  )
}) as ForwardRefComponent<PageTitleProps>;

PageTitle.displayName = 'PageTitle';
